var padDate=function(va){
  va=va<10?'0'+va:va;
  return va
}
const dfilters = {
  formatDate:function (val) {
    var value=new Date(val);
    var year=value.getFullYear();
    var month=padDate(value.getMonth()+1);
    var days=padDate(value.getDate());

    var minute = 1000 * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var week = day * 7;
    var months = day * 30;
    var time1 = new Date().getTime();//当前的时间戳
    var time2 = Date.parse(new Date(val));//指定时间的时间戳
    var time = time1 - time2;
    var result = null;
     if (time / months >= 1) {
      result = year+'-'+month+'-'+days+' '
    } else if (time / week >= 1) {
        result = year+'-'+month+'-'+days+' '
    } else if (time / day >= 1) {
        result =  parseInt(time / day) + "天前";
    } else if (time / hour >= 1) {
        result = parseInt(time / hour) + "小时前";
    } else if (time / minute >= 1) {
        result = parseInt(time / minute) + "分钟前";
    } else {
        result = "刚刚";
    }
    return result;

    // return year+'-'+month+'-'+days+' '
  },
  dUpdateTime(value) {
      var data = value.substring(5, 10);
      return data;
    },
  filterRecruitNum(value) {
    switch (value) {
      case -1:
        return '若干';
        break;
      default:
        return value;
        break;
    }
  },
  filterNature(value) {
    switch (value) {
      case 0:
        return '兼职';
        break;
      case 1:
        return '全职';
        break;
    }
  },
}
export default dfilters;



// WEBPACK FOOTER //
// ./src/utils/dfilters.js